import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  status: '',
  sex: '',
  city: '',
  email: '',
  phone: '',
  additionalParticipant1: '',
  additionalParticipant2: '',
  additionalDetails: '',
  currentDate: '',
  appointmentStartDate: '',
  appointmentEndDate: '',
  appointmentTimeDuration: '',
  selectedDate: '',
  selectedTimeSlot: '',
  fileNumber: '',
  existingCustomer: false,
  availability: {},
  contactLike: '',
  uploadedFile: null,
  submitting: false,
  submissionError: null,
  userFileNumberBool: false,
  filenumberValidate: false,
};

const bookingFormSlice = createSlice({
  name: 'bookingForm',
  initialState,
  reducers: {
    setName: (state, action) => {
      state.name = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setSex: (state, action) => {
      state.sex = action.payload;
    },
    setCity: (state, action) => {
      state.city = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setPhone: (state, action) => {
      state.phone = action.payload;
    },
    setAdditionalParticipant1: (state, action) => {
      state.additionalParticipant1 = action.payload;
    },
    setAdditionalParticipant2: (state, action) => {
      state.additionalParticipant2 = action.payload;
    },
    setAdditionalDetails: (state, action) => {
      state.additionalDetails = action.payload;
    },
    setCurrentDate: (state, action) => {
      state.currentDate = action.payload;
    },
    setAppointmentStartDate: (state, action) => {
      state.appointmentStartDate = action.payload;
    },
    setAppointmentEndDate: (state, action) => {
      state.appointmentEndDate = action.payload;
    },
    setAppointmentTimeDuration: (state, action) => {
      state.appointmentTimeDuration = action.payload;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setSelectedTimeSlot: (state, action) => {
      state.selectedTimeSlot = action.payload;
    },
    setAvailability: (state, action) => {
      state.availability = action.payload;
    },
    setContactLike: (state, action) => {
      state.contactLike = action.payload;
    },
    setFileNumber: (state, action) => {
      state.fileNumber = action.payload;
    },
    setExistingCustomer: (state, action) => {
      state.existingCustomer = action.payload;
    },
    setUserFileNumberBool: (state, action) => {
      state.userFileNumberBool = action.payload;
    },
    setFileNumberValidate: (state,action)=>{
      state.filenumberValidate = action.payload;
    },
    setUploadedFile: (state, action) => {
      state.uploadedFile = action.payload;
    },
    resetForm: () => initialState,
    submitForm: (state) => {
      state.submitting = true;
      state.submissionError = null;
    },
    submitFormSuccess: (state) => {
      state.submitting = false;
      state.submissionError = null;
    },
    submitFormFailure: (state, action) => {
      state.submitting = false;
      state.submissionError = action.payload;
    },
  },
});

export const {
  setName,
  setStatus,
  setSex,
  setCity,
  setEmail,
  setPhone,
  setAdditionalParticipant1,
  setAdditionalParticipant2,
  setAdditionalDetails,
  setCurrentDate,
  setAppointmentStartDate,
  setAppointmentEndDate,
  setAppointmentTimeDuration,
  setSelectedDate,
  setSelectedTimeSlot,
  setAvailability,
  setContactLike,
  setUploadedFile,
  setFileNumber,
  setExistingCustomer,
  setUserFileNumber,
  setUserFileNumberBool,
  setFileNumberValidate,
  resetForm,
  submitForm,
  submitFormSuccess,
  submitFormFailure,
} = bookingFormSlice.actions;

export default bookingFormSlice.reducer;
